<template>
    <div class="flex flex-align-center flex-pack-center register-form">
        <div class="logo">
            <img src="../../assets/login/logo2.png" height="56" width="184" alt="">
        </div>
        <div class="register">
            <div class="returnBtn" @click="$router.push({path:'/login'})"><i class="iconfont icon-return"></i></div>
            <div class="title" v-text="status?'重置密码':'注册'"></div>
            <form @submit.prevent="register">
                <div>
                    <input type="tel" class="user" v-model="phone" placeholder="请输入您的手机号码">
                </div>
                <div class="codeBox">
                    <input type="tel" class="code" v-model="code" placeholder="请输入验证码">
                    <span class="sendCode" v-if="!isGetCode" @click="getCode">获取验证码</span>
                    <span class="sendCode" v-if="isGetCode">{{time+' s'}}</span>
                </div>
                <div>
                    <input type="password" class="password" v-model="password" placeholder="请输入密码">
                </div>
                <div class="getCodeTip" :style="{'visibility':(isShowCodeTip?'visible':'hidden')}">已发送验证码至您的手机</div>
                <div class="confirmBtn">
                    <button type="submit" v-text="status?'提交':'下一步'"></button>
                </div>
            </form>
        </div>
    </div>
</template>

<script type="text/javascript">
    import {url} from '@/router/url.js';
    import {API_BASE_URL} from "./../../urlConfig/index";
    export default{
    	data () {
    		return {
                isShowCodeTip:false, // 是否显示验证嘛提示
                isGetCode:false, // 是否获取验证码
                time:60,
                phone:'', // 手机号
                password: '', // 密码
                code: '', // 验证码
                status:'',//注册或者重置密码控制
    		}
    	},
        methods: {
            reWord(){

            },
            getCode: function () {
                this.phone = this.phone.replace(/\s+/g, "");
                if ( (/^1[3|4|5|6|7|8|9][0-9]{9}$/).test(this.phone) ) {
                    this.isGetCode = true;
                    this.$http.post(API_BASE_URL+'v1/verify-code?mobile='+this.phone+'&type=ACCOUNT').then((res)=>{
                        this.isShowCodeTip = true;
                        let intervalCode = setInterval(()=>{
                            this.time--;
                            if ( this.time <= 0 ) {
                                this.isGetCode = false;
                                this.isShowCodeTip = false;
                                this.time = 60;
                                clearInterval(intervalCode);
                            }
                        }, 1000);
                    }).catch((err)=>{
                        this.isGetCode = false;
                        this.isShowCodeTip = false;
                    })
                } else {
                    this.$message({
                        message: '请输入正确的手机号',
                        customClass: 'error'
                    });
                    return;                   
                }
            },
            register: function () {
                if ( !(/^1[3|4|5|6|7|8|9][0-9]{9}$/.test(this.phone)) ) {
                    this.$message({
                        message: '请输入正确的手机号',
                        customClass: 'error'
                    });
                    return;   
                }
                if ( !this.code || this.code.length !== 4 ) {
                    this.$message({
                        message: '请填写正确的验证码',
                        customClass: 'error'
                    });
                    return;
                }
                if ( !this.password ) {
                    this.$message({
                        message:'请输入密码',
                        customClass:'error'
                    });
                    return;
                }
                /*验证密码*/
                let data = {
                    "username": this.phone,
                    "verCode": this.code,
                    // "password": hex_md5(this.password)
                    "password": this.password
                }
                if(this.status){
                    //是  重置密码
                    let resetData = {
                        "mobile": this.phone,
                        "verifyCode": this.code,
                        // "password": hex_md5(this.password)
                        "pwd": this.password
                    }
                    this.$http.post('reset-pwd', resetData).then((res)=>{
                        this.$message({
                            message:"重置密码成功,请登录",
                            customClass:"success",
                        });
                        this.$router.push({path:'/login'});
                    }).catch((err)=>{
                        
                    })
                }else{
                    this.$message({
                        message:"正在注册中，请等待页面自动跳转...",
                        customClass:"success",
                        duration:5000
                    });
                    //否  注册
                    this.$http.post('sign-up', data).then((res)=>{
                        this.login();
                    }).catch((err)=>{
                        
                    })
                }
            },
            login: function () { // 登录事件
                let data = {
                    "username": this.phone,
                    // "password": hex_md5(this.password),
                    "password": this.password,
                }
                let b = new Base64();
                let authStr = 'Basic '+ b.encode(data.username+':'+data.password);
                this.$http.post('login', {}, {
                    auth: data // 添加登录验证
                }).then((res)=>{
                    localStorage.setItem('token', authStr);
                    localStorage.setItem('username', this.phone);
                    this.$router.push({path:'/store'});
                }).catch((err)=>{

                })
            }
        },
        created(){
            this.status = this.$route.params.foo == 'reset';
        },
    }
</script>
<style lang="scss" scoped>
    @import '../../../static/css/common.scss';
	@import "register";
</style>



// WEBPACK FOOTER //
// register.vue?d7ca155a